import { MasterUserTypeEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/master-user-type.enum";
import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";

export function getISVofTotal(price: string|number, tax: string|number) {
    let p = Number(price); // incluye
    let t = Number(tax); // porcentaje
    let isv = p - (p / (1 + (t / 100)));
    return isv;
}

export function calculateTotalPriceAndTax(price: string | number, tax: string | number) {
  let p = Number(price);     // Precio sin impuesto
  let t = Number(tax);       // Tasa de impuesto (en porcentaje)
  
  let isv = p * (t / 100);   // Cálculo del impuesto
  let totalPrice = p + isv;  // Precio total (producto + impuesto)
  
  return {
      taxAmount: isv,        // Valor del impuesto
      totalPrice: totalPrice // Precio final con impuesto incluido
  };
}

export function matchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
    return (group: FormGroup) => {
        let password = group.controls[passwordKey];
        let passwordConfirmation = group.controls[passwordConfirmationKey];

        if (password.value !== passwordConfirmation.value) {
            return passwordConfirmation.setErrors({ mismatchedPasswords: true })
        }
    }
}

export class CustomValidators {
    static patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
      return (control: AbstractControl): { [key: string]: any } => {
        if (!control.value) { // if control is empty return no error
          return null;
        }
  
        const valid = regex.test(control.value);  // test the value of the control against the regexp supplied
        return valid ? null : error;
      };
    }
}

export function businessPartnerRequiredValidator(): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const type = formGroup.get('type')?.value;
    const businessPartnerId = formGroup.get('businessPartnerId')?.value;

    if (type === 'SOCIOS DE NEGOCIO' && !businessPartnerId) {
      return { businessPartnerRequired: true };
    }

    return null;
  };
}
